// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Carte de France d'affectation. Reutilise la geometrie du PerimetreSelector ; logique propre :
   departements colores par affecte, hors-perimetre grises, selection multiple au lisere. */
.carte-affectation {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.carte-affectation-canvas {
  position: relative;
}

.carte-affectation-svg {
  width: 100%;
  height: auto;
  display: block;
}

/* Departement : trait blanc fin par defaut, transition douce. */
.carte-dept {
  stroke: #ffffff;
  stroke-width: 0.5;
  transition: opacity 0.12s ease, stroke 0.12s ease;
}

/* Hors perimetre : gris fonce, non interactif (bien distinct du non-affecte blanc). */
.carte-dept--hors {
  fill: #6b7280;
  stroke: #ffffff;
  cursor: default;
}

/* Dans le perimetre, non affecte : gris clair (comme l'ancien tableau), cliquable.
   Trait plus marque (#9ca3af) que le fond -> les frontieres entre non-affectes restent visibles. */
.carte-dept--libre {
  fill: #e5e7eb;
  stroke: #9ca3af;
  stroke-width: 0.7;
  cursor: pointer;
}

/* Dans le perimetre, affecte : la couleur (de l'affecte) est posee en inline. */
.carte-dept--affecte {
  cursor: pointer;
}

.carte-dept--libre:hover,
.carte-dept--affecte:hover {
  opacity: 0.82;
}

/* Selectionne : lisere fonce par-dessus la couleur de fond. */
.carte-dept.is-selected {
  stroke: #111827;
  stroke-width: 2;
}

/* Survol d'une personne : les departements qui ne sont pas a elle s'effacent. */
.carte-dept.is-attenue {
  opacity: 0.22;
}

/* Lecture seule (apercu annuaire) : pas d'affordance de clic (l'infobulle reste). */
.carte-affectation.is-readonly .carte-dept--affecte,
.carte-affectation.is-readonly .carte-dept--libre,
.carte-affectation.is-readonly .carte-dom-card {
  cursor: default;
}
.carte-affectation.is-readonly .carte-dept:hover {
  opacity: 1;
}

/* Calque de selection rendu APRES tous les departements : son lisere noir complet passe
   par-dessus les voisins, donc la frontiere commune entre deux depts est entierement noire. */
.carte-dept-selection {
  fill: none;
  stroke: #111827;
  stroke-width: 2;
  stroke-linejoin: round;
  pointer-events: none;
}

/* ── Outre-mer : mini-cartes en grille (geometrie propre par DOM). ── */
.carte-affectation-outremer {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}
.carte-affectation-outremer-label {
  font-size: 1.2rem;
  font-weight: 600;
  color: #595959;
}
.carte-affectation-dom-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 0.8rem;
}
.carte-dom-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.2rem;
  width: 7rem;
  padding: 0.4rem;
  border: 1px solid #e5e7eb;
  border-radius: 0.6rem;
  background: #ffffff;
  cursor: pointer;
}
/* Hors perimetre (bouton disabled) : non cliquable mais PAS eclairci -> meme gris fonce que la
   metropole. L'attenuation est reservee a l'enregistrement (voile global ci-dessous). */
.carte-dom-card:disabled {
  cursor: default;
}
.carte-dom-card.is-selected {
  border-color: #111827;
}
.carte-dom-svg {
  width: 100%;
  height: 4rem;
}
.carte-dom-name {
  font-size: 1rem;
  color: #374151;
  text-align: center;
}

/* ── Infobulle : departement + affecte. ── */
.carte-affectation-tooltip {
  position: fixed;
  z-index: 1200;
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
  max-width: 26rem;
  padding: 0.5rem 0.7rem;
  background: #111827;
  color: #ffffff;
  border-radius: 0.5rem;
  font-size: 1.1rem;
  pointer-events: none;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.25);
}
.carte-affectation-tooltip span {
  color: #d1d5db;
  font-size: 1rem;
}
.carte-affectation-tooltip-coord {
  overflow-wrap: anywhere;
}

/* ── Voile d'enregistrement : feedback + blocage du clic. ── */
.carte-affectation.is-saving .carte-affectation-svg {
  pointer-events: none;
}
/* Enregistrement : on attenue aussi les mini-cartes outre-mer (parite avec le voile metropole). */
.carte-affectation.is-saving .carte-affectation-outremer {
  opacity: 0.6;
  pointer-events: none;
}
.carte-affectation-saving {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.45);
  animation: carte-affectation-pulse 1.2s ease-in-out infinite;
}
.carte-affectation-saving-pill {
  padding: 0.5rem 1.2rem;
  background: #f97316;
  color: #ffffff;
  font-weight: 700;
  border-radius: 999px;
}
@keyframes carte-affectation-pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.6; }
}
`, "",{"version":3,"sources":["webpack://./src/composants/AffectationCarte/CarteAffectation.css"],"names":[],"mappings":"AAAA;2FAC2F;AAC3F;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,gEAAgE;AAChE;EACE,eAAe;EACf,iBAAiB;EACjB,iDAAiD;AACnD;;AAEA,sFAAsF;AACtF;EACE,aAAa;EACb,eAAe;EACf,eAAe;AACjB;;AAEA;mGACmG;AACnG;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA,gFAAgF;AAChF;EACE,eAAe;AACjB;;AAEA;;EAEE,aAAa;AACf;;AAEA,8DAA8D;AAC9D;EACE,eAAe;EACf,eAAe;AACjB;;AAEA,gFAAgF;AAChF;EACE,aAAa;AACf;;AAEA,oFAAoF;AACpF;;;EAGE,eAAe;AACjB;AACA;EACE,UAAU;AACZ;;AAEA;8FAC8F;AAC9F;EACE,UAAU;EACV,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA,wEAAwE;AACxE;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;AACjB;AACA;wFACwF;AACxF;EACE,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA,6CAA6C;AAC7C;EACE,eAAe;EACf,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,0CAA0C;AAC5C;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,uBAAuB;AACzB;;AAEA,+DAA+D;AAC/D;EACE,oBAAoB;AACtB;AACA,kGAAkG;AAClG;EACE,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,4DAA4D;AAC9D;AACA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB","sourcesContent":["/* Carte de France d'affectation. Reutilise la geometrie du PerimetreSelector ; logique propre :\n   departements colores par affecte, hors-perimetre grises, selection multiple au lisere. */\n.carte-affectation {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.carte-affectation-canvas {\n  position: relative;\n}\n\n.carte-affectation-svg {\n  width: 100%;\n  height: auto;\n  display: block;\n}\n\n/* Departement : trait blanc fin par defaut, transition douce. */\n.carte-dept {\n  stroke: #ffffff;\n  stroke-width: 0.5;\n  transition: opacity 0.12s ease, stroke 0.12s ease;\n}\n\n/* Hors perimetre : gris fonce, non interactif (bien distinct du non-affecte blanc). */\n.carte-dept--hors {\n  fill: #6b7280;\n  stroke: #ffffff;\n  cursor: default;\n}\n\n/* Dans le perimetre, non affecte : gris clair (comme l'ancien tableau), cliquable.\n   Trait plus marque (#9ca3af) que le fond -> les frontieres entre non-affectes restent visibles. */\n.carte-dept--libre {\n  fill: #e5e7eb;\n  stroke: #9ca3af;\n  stroke-width: 0.7;\n  cursor: pointer;\n}\n\n/* Dans le perimetre, affecte : la couleur (de l'affecte) est posee en inline. */\n.carte-dept--affecte {\n  cursor: pointer;\n}\n\n.carte-dept--libre:hover,\n.carte-dept--affecte:hover {\n  opacity: 0.82;\n}\n\n/* Selectionne : lisere fonce par-dessus la couleur de fond. */\n.carte-dept.is-selected {\n  stroke: #111827;\n  stroke-width: 2;\n}\n\n/* Survol d'une personne : les departements qui ne sont pas a elle s'effacent. */\n.carte-dept.is-attenue {\n  opacity: 0.22;\n}\n\n/* Lecture seule (apercu annuaire) : pas d'affordance de clic (l'infobulle reste). */\n.carte-affectation.is-readonly .carte-dept--affecte,\n.carte-affectation.is-readonly .carte-dept--libre,\n.carte-affectation.is-readonly .carte-dom-card {\n  cursor: default;\n}\n.carte-affectation.is-readonly .carte-dept:hover {\n  opacity: 1;\n}\n\n/* Calque de selection rendu APRES tous les departements : son lisere noir complet passe\n   par-dessus les voisins, donc la frontiere commune entre deux depts est entierement noire. */\n.carte-dept-selection {\n  fill: none;\n  stroke: #111827;\n  stroke-width: 2;\n  stroke-linejoin: round;\n  pointer-events: none;\n}\n\n/* ── Outre-mer : mini-cartes en grille (geometrie propre par DOM). ── */\n.carte-affectation-outremer {\n  display: flex;\n  flex-direction: column;\n  gap: 0.6rem;\n}\n.carte-affectation-outremer-label {\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: #595959;\n}\n.carte-affectation-dom-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.8rem;\n}\n.carte-dom-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.2rem;\n  width: 7rem;\n  padding: 0.4rem;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.6rem;\n  background: #ffffff;\n  cursor: pointer;\n}\n/* Hors perimetre (bouton disabled) : non cliquable mais PAS eclairci -> meme gris fonce que la\n   metropole. L'attenuation est reservee a l'enregistrement (voile global ci-dessous). */\n.carte-dom-card:disabled {\n  cursor: default;\n}\n.carte-dom-card.is-selected {\n  border-color: #111827;\n}\n.carte-dom-svg {\n  width: 100%;\n  height: 4rem;\n}\n.carte-dom-name {\n  font-size: 1rem;\n  color: #374151;\n  text-align: center;\n}\n\n/* ── Infobulle : departement + affecte. ── */\n.carte-affectation-tooltip {\n  position: fixed;\n  z-index: 1200;\n  display: flex;\n  flex-direction: column;\n  gap: 0.1rem;\n  max-width: 26rem;\n  padding: 0.5rem 0.7rem;\n  background: #111827;\n  color: #ffffff;\n  border-radius: 0.5rem;\n  font-size: 1.1rem;\n  pointer-events: none;\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.25);\n}\n.carte-affectation-tooltip span {\n  color: #d1d5db;\n  font-size: 1rem;\n}\n.carte-affectation-tooltip-coord {\n  overflow-wrap: anywhere;\n}\n\n/* ── Voile d'enregistrement : feedback + blocage du clic. ── */\n.carte-affectation.is-saving .carte-affectation-svg {\n  pointer-events: none;\n}\n/* Enregistrement : on attenue aussi les mini-cartes outre-mer (parite avec le voile metropole). */\n.carte-affectation.is-saving .carte-affectation-outremer {\n  opacity: 0.6;\n  pointer-events: none;\n}\n.carte-affectation-saving {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.45);\n  animation: carte-affectation-pulse 1.2s ease-in-out infinite;\n}\n.carte-affectation-saving-pill {\n  padding: 0.5rem 1.2rem;\n  background: #f97316;\n  color: #ffffff;\n  font-weight: 700;\n  border-radius: 999px;\n}\n@keyframes carte-affectation-pulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.6; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
